import { IBaseModel } from '../../shared/interfaces/IBaseModel';
import { IPagination } from '../../shared/interfaces/IPagination';
import { IUser } from '../../shared/interfaces/IUser';
import { formDataHeaders, requests } from '../../utils/api/api.service';
import { USER_URL } from '../../utils/api/endpoints';

export const AdminUserService = {
  getAll: (data: IPagination): Promise<IBaseModel<IUser[]>> =>
    requests.get(USER_URL, data),
  update: (data: FormData, id: number): Promise<IUser> =>
    requests.put(`${USER_URL}/${id}`, data, formDataHeaders),
  create: (data: FormData): Promise<IUser> =>
    requests.post(USER_URL, data, formDataHeaders),
  delete: (id: number): Promise<IUser> => requests.delete(`${USER_URL}/${id}`),
  getDashboardData: () => requests.get(`${USER_URL}/dashboard-data`),
};
